import { render, staticRenderFns } from "./FacturasxDia.vue?vue&type=template&id=7a2f037d&"
import script from "./FacturasxDia.vue?vue&type=script&lang=js&"
export * from "./FacturasxDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports